import router from './router';
import { getCache } from '@/utils/session';
import getPageTitle from '@/utils/getPageTitle';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style

NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  document.title = getPageTitle(to.meta.title);
  const isLogin = getCache('TOKEN');
  const userInfo = getCache('USERINFO');
  console.log('路由拦截器 - 目标路径:', to.path);
  console.log('路由拦截器 - 来源路径:', from.path);
  console.log('路由拦截器 - 是否有token:', !!isLogin);
  if (to.path == '/login') {
    console.log('路由拦截器 - 跳转到登录页');
    next();
    NProgress.done();
  } else {
    if (!isLogin || !userInfo) {
      console.log('路由拦截器 - 无token或无用户信息，重定向到登录页');
      // 清除缓存，防止脏数据
      import('@/store').then(storeModule => {
        storeModule.default.dispatch('user/logout', true);
        next('/login');
      });
    } else {
      console.log('路由拦截器 - 有token且有用户信息，允许访问');
      // 注释掉权限相关逻辑，直接放行
      next();
      // 移除这里的 NProgress.done()，因为 afterEach 会处理

      // 原来的权限逻辑（已注释）
      /*
      const route = store.state.permission.routes;
      if (route.length > 0) {
        next();
        NProgress.done();
      } else {
        const userInfo = store.state.user.accountInfo;
        try {
          const { role, account } = userInfo;
          const accountRoute = await store.dispatch('permission/getRoute', { role, account });
            await store.dispatch('user/feactWarning');
          router.addRoutes(accountRoute);
          if (from.path == '/login') {
            next(accountRoute[0].children[0].path);
          } else {
            next({ ...to, replace: true });
          }
          NProgress.done();
        } catch (error) {
          console.log(error);
          message.error('获取用户信息失败');
          next('/login');
          NProgress.done();
        }
      }
      */
    }
  }
});
router.afterEach(() => {
  NProgress.done();
});